import React from 'react';
import { useTranslation } from 'react-i18next';
import { Star, Car, KeyRound, Clock, Wifi } from 'lucide-react';
import './TrustBar.css';

// Compact strip of verifiable trust signals to reassure visitors and lift
// conversion. All copy is i18n (common:trust); icons from lucide-react.
const TRUST_ITEMS = [
    { key: 'rating', Icon: Star },
    { key: 'parking', Icon: Car },
    { key: 'selfCheckIn', Icon: KeyRound },
    { key: 'fastReply', Icon: Clock },
    { key: 'wifi', Icon: Wifi },
];

const TrustBar = () => {
    const { t } = useTranslation('common');

    return (
        <section className="trust-bar" aria-label={t('trust.rating')}>
            <ul className="trust-bar-list">
                {TRUST_ITEMS.map(({ key, Icon }) => (
                    <li key={key} className="trust-bar-item">
                        <Icon size={20} aria-hidden="true" />
                        <span>{t(`trust.${key}`)}</span>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default TrustBar;
